// Central SEO config for MM Byggeri & Rådgivning
// All titles, descriptions and OG metadata live here — one source of truth.

export const SITE_URL = "https://mmbr.dk";
export const SITE_NAME = "MM Byggeri & Rådgivning";
export const DEFAULT_OG_IMAGE =
    `${SITE_URL}/images/diningHall-og.jpg`;

/**
 * Static route metadata.
 * Dynamic routes (e.g. /cases/:slug) are resolved separately in the page component.
 */
export const seoByPath = {
    "/": {
        title: "MM Byggeri & Rådgivning — Eksklusivt håndværk i København & Nordsjælland",
        description:
            "Eksklusivt byggeri, totalrenovering, snedkerarbejde og rådgivning for design- og kvalitetsbevidste bygherrer i København og Nordsjælland. Udførelsespartner for arkitekter.",
        ogImage: DEFAULT_OG_IMAGE,
        type: "website",
    },
    "/cases": {
        title: "Cases — Udvalgte renoveringer & nybyg | MM Byggeri & Rådgivning",
        description:
            "Udvalgte eksklusive projekter. Totalrenovering af historisk villa i Hellerup og nyopført sommerhus i Hornbæk. Snedkerarbejde, materialer og detaljer i særklasse.",
        ogImage: DEFAULT_OG_IMAGE,
        type: "website",
    },
    "/privat": {
        title: "Privat bygherre — Eksklusiv renovering & nybyg | MM Byggeri",
        description:
            "Vi arbejder tæt sammen med private bygherrer i Nordsjælland og København om totalrenovering, tilbygning og sommerhusbyggeri, hvor håndværk, materialer og detaljer står i centrum.",
        ogImage:
            `${SITE_URL}/images/brassTap-og.jpg`,
        type: "website",
    },
    "/arkitekter": {
        title: "For arkitekter — Udførelsespartner med respekt for tegningen | MM Byggeri",
        description:
            "Vi udfører arkitekttegnet byggeri i særklasse — totalentrepriser, snedkerarbejde og materialer. Drawing-respectful samarbejde med arkitekter i København og Nordsjælland.",
        ogImage:
            `${SITE_URL}/images/copperDetail-og.jpg`,
        type: "website",
    },
    "/om-os": {
        title: "Om MM Byggeri & Rådgivning — Snedkerarbejde & rådgivning i øjenhøjde",
        description:
            "Vi er bygmestre, snedkere og rådgivere, der skaber eksklusive hjem i København og Nordsjælland — med fokus på håndværk, materialer og en respekt for detaljen.",
        ogImage:
            `${SITE_URL}/images/stairOverhead-og.jpg`,
        type: "website",
    },
    "/kontakt": {
        title: "Kontakt MM Byggeri & Rådgivning — Eksklusivt byggeri i Nordsjælland",
        description:
            "Kontakt MM Byggeri & Rådgivning for en samtale om dit projekt. Totalrenovering, tilbygning, sommerhus eller arkitektsamarbejde i København og Nordsjælland.",
        ogImage:
            `${SITE_URL}/images/corridorSteel-og.jpg`,
        type: "website",
    },
    "/cookie-politik": {
        title: "Cookie-politik | MM Byggeri & Rådgivning",
        description:
            "Information om brug af cookies på mmbr.dk — hvilke typer vi anvender, og hvordan du administrerer dit samtykke.",
        ogImage: DEFAULT_OG_IMAGE,
        type: "website",
        noindex: true,
    },
    "/vilkaar": {
        title: "Vilkår & betingelser | MM Byggeri & Rådgivning",
        description:
            "Forretningsbetingelser og vilkår for samarbejde med MM Byggeri & Rådgivning.",
        ogImage: DEFAULT_OG_IMAGE,
        type: "website",
        noindex: true,
    },
};

/**
 * Build SEO for a case detail page from the case record.
 */
export const seoForCase = (caseItem) => {
    if (!caseItem) return null;
    const titleDa = caseItem.title?.da || "Case";
    const location = caseItem.location?.da || "";
    const scope = caseItem.scope?.da || "";
    return {
        title: `${titleDa} — ${location} | MM Byggeri & Rådgivning`,
        description: `${caseItem.subtitle?.da || ""}. ${location && `Case fra ${location}.`} ${scope}. Eksklusivt byggeri af MM Byggeri & Rådgivning.`.trim(),
        ogImage: caseItem.hero ? `${SITE_URL}${caseItem.hero}-og.jpg` : DEFAULT_OG_IMAGE,
        type: "article",
    };
};

/**
 * Pre-rendered list of ALL routes (for react-snap at build time).
 */
export const prerenderRoutes = [
    "/",
    "/cases",
    "/cases/bengtasvej-6",
    "/cases/kystvej-37b",
    "/privat",
    "/arkitekter",
    "/om-os",
    "/kontakt",
    "/cookie-politik",
    "/vilkaar",
    "/404",
];
